<template>
  <div id="projectList">
    <projectListItem v-for="(item,index) in projectListDatas" :projectListItem="item" :key="index"  @click.native="inDetails(item.detailsSrc)" ></projectListItem>
  </div>
</template>

<script>
import projectListItem from "./projectListItem";
export default {
  name: "projectList",
  props:{
    projectListDatas:{
      type:Array,
      default(){
        return[]
      }
    }
  },
  components:{
    projectListItem
  },
  methods:{
    inDetails(detailsSrc){
      this.$router.replace({path:'/projectDetails',query: {detailsSrc:detailsSrc}})
    }
  }
}
</script>

<style scoped>
  #projectList{
    display: flex;
    width: 1395px;
    height: 690px;
    /*根据宽度决定一行显示多少*/
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
    margin: 0 auto;
  }
</style>